import React from 'react';

export default class HeaderBarUI extends React.Component {
    render() {
        return (
            <>
                <aside className="users-name text-end fw-bold mx-3 my-1">{this.props.userName}</aside>
                <div className="header-bar shadow">
                    <img src={this.props.headerImageURL} />
                </div>
            </>
        );
    }
}
